module.exports = __webpack_public_path__ + "static/media/photoTaker_none@3x.cff13c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photoTaker_none@3x.png
// module id = 210
// module chunks = 0